import Hammer from 'hammerjs';
/**
 * Image gallery functionality
 * @class
 */
export default class ImageGallery {
    /**
     * @constructor
     * @param {HTMLElement} element The image gallery root element
     */
    constructor(element) {
        var _a;
        this.element = element;
        this.key = (_a = element.getAttribute("data-modal")) !== null && _a !== void 0 ? _a : "";
        this.items = element.querySelectorAll('[data-component="GalleryItem"]');
        this.isMobile = this.checkIsMobile();
        this.initModal = this.initModal.bind(this);
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.next = this.next.bind(this);
        this.slide = this.slide.bind(this);
        window.addEventListener("resize", () => {
            this.isMobile = this.checkIsMobile();
            if (this.isMobile) {
                this.initSlider();
            }
            else {
                this.destroySlider();
            }
        });
        this.gallery = [...this.items].map(item => {
            var _a, _b, _c, _d, _e;
            item.addEventListener('click', this.open);
            item.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    this.open(event);
                }
            });
            const crops = (_a = item.getAttribute('data-crops')) === null || _a === void 0 ? void 0 : _a.split("'nextCrop'");
            return {
                id: (_b = item.getAttribute('data-id')) !== null && _b !== void 0 ? _b : '',
                src: (_c = item.getAttribute('data-src')) !== null && _c !== void 0 ? _c : '',
                alt: (_d = item.getAttribute('data-alt')) !== null && _d !== void 0 ? _d : '',
                caption: (_e = item.getAttribute('data-caption')) !== null && _e !== void 0 ? _e : '',
                crops: crops !== null && crops !== void 0 ? crops : '',
                element: item
            };
        });
        if (this.isMobile) {
            this.initSlider();
        }
        else {
            this.destroySlider();
        }
        if (this.key) {
            this.initModal();
        }
    }
    checkIsMobile() {
        const width = window.innerWidth;
        if (width < 768) {
            return true;
        }
        return false;
    }
    initSlider() {
        this.slider = {
            element: this.element.querySelector('[data-component="Slider"]'),
            slides: [...this.element.querySelectorAll('[data-component="Slide"]')].map((slide, index) => {
                const element = slide;
                element.style.transform = `translateX(${index * 104.27}%)`;
                return {
                    id: '',
                    element: slide,
                    currentIndex: 0
                };
            }),
            currentIndex: 0,
            isSliding: false,
            height: 0,
        };
        this.slider.slides.forEach(slide => {
            const media = slide.element.querySelector('img');
            if (this.slider) {
                if (media && media.clientHeight > this.slider.height) {
                    this.slider.height = media.clientHeight;
                    this.slider.element.style.height = `${media.clientHeight}px`;
                }
            }
        });
        if (this.slider) {
            const hammer = new Hammer(this.slider.element);
            this.slider.slides[0].element.classList.add('is-active');
            hammer.on('swiperight', () => {
                this.slide('left');
            });
            hammer.on('swipeleft', () => {
                this.slide('right');
            });
        }
    }
    destroySlider() {
        var _a;
        (_a = this.slider) === null || _a === void 0 ? void 0 : _a.element.style.removeProperty('height');
        [...this.element.querySelectorAll('[data-component="Slide"]')].forEach((slide, index) => {
            const element = slide;
            element.style.removeProperty('transform');
        });
        this.slider = undefined;
    }
    initModal() {
        var _a, _b, _c, _d, _e, _f;
        const modalEl = document.querySelector(`[data-component="Modal"][data-id="${this.key}"]`);
        if (modalEl) {
            this.modal = {
                id: this.key,
                element: modalEl,
                loading: modalEl.querySelector('[data-component="Loading"]'),
                media: modalEl.querySelector('[data-component="Media"]'),
                buttons: {
                    close: modalEl.querySelectorAll('[data-button="CloseModal"]'),
                    next: modalEl.querySelectorAll('[data-button="GalleryGoTo"][data-direction="Next"]'),
                    prev: modalEl.querySelectorAll('[data-button="GalleryGoTo"][data-direction="Prev"]'),
                },
                caption: modalEl.querySelector('[data-component="Caption"]'),
                pagination: modalEl.querySelector('[data-component="Pagination"]')
            };
            (_b = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.buttons) === null || _b === void 0 ? void 0 : _b.close.forEach(button => button.addEventListener('click', this.close));
            (_d = (_c = this.modal) === null || _c === void 0 ? void 0 : _c.buttons) === null || _d === void 0 ? void 0 : _d.prev.forEach(button => button.addEventListener('click', this.next));
            (_f = (_e = this.modal) === null || _e === void 0 ? void 0 : _e.buttons) === null || _f === void 0 ? void 0 : _f.next.forEach(button => button.addEventListener('click', this.next));
            window.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') {
                    this.close();
                }
                if (event.key === 'ArrowLeft') {
                }
            });
        }
    }
    handleKeyUp(evt) {
        if ((evt === null || evt === void 0 ? void 0 : evt.key) === "Escape") {
            this.close();
        }
        else {
            document.addEventListener("keyup", (evt) => this.handleKeyUp(evt), {
                once: true,
            });
        }
    }
    open(event) {
        var _a, _b, _c, _d, _e, _f;
        event.preventDefault();
        const targetElement = event.target;
        const element = targetElement.closest('[data-component="GalleryItem"]');
        const item = (_a = this.gallery) === null || _a === void 0 ? void 0 : _a.find(item => item.id === element.getAttribute('data-id'));
        const nextButton = (_c = (_b = this.modal) === null || _b === void 0 ? void 0 : _b.buttons) === null || _c === void 0 ? void 0 : _c.next[0];
        if (((_d = this.slider) === null || _d === void 0 ? void 0 : _d.isSliding) === true)
            return false;
        if (item) {
            this.updateModal(item);
        }
        (_f = (_e = this.modal) === null || _e === void 0 ? void 0 : _e.element) === null || _f === void 0 ? void 0 : _f.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        nextButton === null || nextButton === void 0 ? void 0 : nextButton.focus();
    }
    close() {
        var _a, _b;
        (_b = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.element) === null || _b === void 0 ? void 0 : _b.classList.remove('is-open');
        document.body.style.overflowY = 'visible';
    }
    next(event) {
        var _a;
        const targetElement = event.target;
        const element = targetElement.closest('[data-button="GalleryGoTo"]');
        const nextItemIndex = (_a = element.getAttribute('data-target')) !== null && _a !== void 0 ? _a : '0';
        if (this.gallery) {
            const nextItem = this.gallery[parseInt(nextItemIndex)];
            this.updateModal(nextItem);
        }
    }
    updateModal(item) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const media = this.buildPicture(item.src, item.alt, item.crops);
        (_b = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.media) === null || _b === void 0 ? void 0 : _b.replaceChildren('');
        const currentIndex = (_c = this.gallery) === null || _c === void 0 ? void 0 : _c.indexOf(item);
        if (currentIndex != undefined && currentIndex >= 0 && this.gallery) {
            const nextIndex = (currentIndex + 1) % ((_d = this.gallery) === null || _d === void 0 ? void 0 : _d.length);
            const prevIndex = currentIndex != 0 ? (currentIndex - 1) : ((_e = this.gallery) === null || _e === void 0 ? void 0 : _e.length) - 1;
            (_g = (_f = this.modal) === null || _f === void 0 ? void 0 : _f.buttons) === null || _g === void 0 ? void 0 : _g.prev.forEach(button => button.setAttribute('data-target', prevIndex.toString()));
            (_j = (_h = this.modal) === null || _h === void 0 ? void 0 : _h.buttons) === null || _j === void 0 ? void 0 : _j.next.forEach(button => button.setAttribute('data-target', nextIndex.toString()));
        }
        (_l = (_k = this.modal) === null || _k === void 0 ? void 0 : _k.media) === null || _l === void 0 ? void 0 : _l.appendChild(media);
        if (this.modal && this.modal.caption) {
            this.modal.caption.innerHTML = item.caption;
        }
        if (this.modal && this.modal.pagination && currentIndex != undefined) {
            this.modal.pagination.innerHTML = `Image ${currentIndex + 1} of ${(_m = this.gallery) === null || _m === void 0 ? void 0 : _m.length}`;
        }
    }
    buildPicture(src, alt, crops) {
        const pictureElement = document.createElement("PICTURE");
        var sc1 = document.createElement("SOURCE");
        var sc2 = document.createElement("SOURCE");
        var sc3 = document.createElement("SOURCE");
        var img = document.createElement("IMG");
        pictureElement.srcset = src;
        sc1.srcset = crops[0];
        sc1.media = "(max-width: 767px)";
        sc1.type = "image/webp";
        sc2.srcset = crops[1];
        sc2.media = "(max-width: 1023px)";
        sc2.type = "image/webp";
        sc3.srcset = crops[2];
        sc3.media = "(min-width: 1024px)";
        sc3.type = "image/webp";
        img.src = src;
        img.srcset = src;
        img.alt = alt;
        pictureElement.appendChild(sc1);
        pictureElement.appendChild(sc2);
        pictureElement.appendChild(sc3);
        pictureElement.appendChild(img);
        return pictureElement;
    }
    slide(direction) {
        var _a;
        if (this.slider) {
            if (!this.isMobile)
                return;
            if (this.slider.slides) {
                if (direction === 'right') {
                    if (this.slider.currentIndex === ((_a = this.slider) === null || _a === void 0 ? void 0 : _a.slides.length) - 1) {
                    }
                    else {
                        this.slider.currentIndex++;
                    }
                }
                else {
                    if (this.slider.currentIndex === 0) {
                    }
                    else {
                        this.slider.currentIndex--;
                    }
                }
            }
            this.slider.slides.forEach((slide, index) => {
                var _a, _b, _c, _d;
                const s = slide.element;
                if (((_a = this.slider) === null || _a === void 0 ? void 0 : _a.currentIndex) !== ((_b = this.slider) === null || _b === void 0 ? void 0 : _b.slides.length)) {
                    if (this.slider) {
                        s.style.transform = `translateX(${104.27 * (index - ((_c = this.slider) === null || _c === void 0 ? void 0 : _c.currentIndex))}%)`;
                    }
                }
                if (((_d = this.slider) === null || _d === void 0 ? void 0 : _d.currentIndex) === index) {
                    s.classList.add('is-active');
                }
                else {
                    s.classList.remove('is-active');
                }
            });
        }
    }
    /**
     * Creates new instances of IImageGalleryUtils for each `.o-navigation-bar` element,
     * and adds the necessary event listeners to support opening and closing of the navigation.
     */
    static init() {
        const imageGalleries = [
            ...document.querySelectorAll('[data-component="ImageGallery"]'),
        ];
        imageGalleries.forEach((gallery) => {
            const imageGalleryUtil = new ImageGallery(gallery);
        });
    }
}
